<template>
  <div class="tag-box">
    <!--操作栏-->
    <div class="action-bar">
      <!-- <el-select
        v-model="params.status"
        placeholder="请选择是否启用"
        clearable
        size="small"
      >
        <el-option
          v-for="item in enables"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select> -->
      <el-button
        type="primary"
        size="small"
        icon="el-icon-search"
        @click="getModules('status')"
        style="margin-right: 20px"
        >搜索</el-button
      >
      <el-button
        type="primary"
        size="small"
        @click="addAndEdit('add')"
        style="margin-right: 20px"
        >新增</el-button
      >
      <!-- <el-button
        type="warning"
        size="small"
        @click="setMarquee()"
        style="margin-right: 20px"
        >配置模块跑马灯</el-button
      > -->
    </div>
    <!--数据表格-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      ref="multipleTable"
      height="600"
    >
      <el-table-column prop="title" label="标题" align="center" min-width="210">
        <template slot-scope="scope">
          <span>{{ scope.row.title || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="desc"
        label="描述"
        align="center"
        min-width="200"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{ scope.row.desc || "-" }}
        </template>
      </el-table-column>
      <el-table-column
        prop="desc"
        label="描述"
        align="center"
        min-width="200"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{ scope.row.desc || "-" }}
        </template>
      </el-table-column>
      <el-table-column
        prop="seriesCover"
        label="图集预览"
        align="center"
        min-width="200"
      >
        <template slot-scope="scope">
          <!-- <span v-if="!scope.row.seriesCover || !scope.row.seriesCover.length">未知</span> -->
          <div
            class="picturePreview"
            @click="previewPicture(scope.row.img)"
            v-if="scope.row.img && scope.row.img.length"
          >
          
                <gallery :list="scope.row.img" ></gallery>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="previewURL"
        label="预览视频"
        align="center"
        width="80"
      >
        <template slot-scope="scope" v-if="scope.row.sourceURL">
          <i
            class="el-icon-video-play views"
            title="点击预览"
            @click="checkMedia(scope.row.sourceURL, 'video')"
          ></i>
        </template>
      </el-table-column>
      <el-table-column prop="sort" label="排序" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.sort || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" align="center" width="120">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.status == 0">关闭</el-tag>
          <el-tag type="danger" v-else-if="scope.row.status == 1"
            >不可参与</el-tag
          >
          <el-tag type="primary" v-else>可参与</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="start"
        label="开始时间"
        align="center"
        width="160px"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.start | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="end" label="结束时间" align="center" width="160px">
        <template slot-scope="scope">
          <span>{{ scope.row.end | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        min-width="180"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="success"
            icon="el-icon-edit"
            @click="addAndEdit(scope.row)"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="success"
            icon="el-icon-message"
            @click="comment(scope.row)"
            >评论</el-button
          >
          <!-- <el-button
            size="mini"
            type="danger"
            icon="el-icon-delete"
            @click="del(scope.row)"
            >删除</el-button
          > -->
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[10, 15, 20, 30]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
    <!-- 新增、修改 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="740px"
      @close="handleClose"
    >
      <el-form :model="form" label-width="100px" :rules="rules" ref="form">
        <el-form-item label="上传视频:" v-if="dialogVisible">
          <!--视频分片上传-->
          <uploader
            :options="options"
            class="uploader-example"
            ref="uploader"
            @file-added="fileAdd"
            @file-success="onFileSuccess"
          >
            <uploader-unsupport></uploader-unsupport>
            <uploader-drop>
              <uploader-btn :attrs="attrs">上传视频</uploader-btn>
            </uploader-drop>
            <uploader-list style="width: 600px"></uploader-list>
          </uploader>
        </el-form-item>
        <el-form-item
          style="width: 600px"
          label="上传图集:"
          prop="seriesCover"
          v-if="dialogVisible"
        >
          <!--上传图集-->
          <imgs-upload
            :cover="form.img"
            :action="actionPics"
            @successCallback="successCallbackPic"
            :id="form.id"
            :wSize="180"
            :hSize="320"
            :width="'100px'"
            :height="'100px'"
            :key="form.id"
          ></imgs-upload>
        </el-form-item>
        <el-form-item label="内容:" prop="seriesCover">
          <el-button
            type="primary"
            size="small"
            @click="editRichText"
            style="margin-right: 20px"
            >编辑富文本</el-button
          >
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input v-model="form.title"></el-input>
        </el-form-item>
        <el-form-item label="发布者ID" prop="publisherID">
          <el-input v-model.number="form.publisherID"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="desc">
          <el-input type="textarea" rows="3" v-model="form.desc"></el-input>
        </el-form-item>
        <el-form-item label="跳转方式:" prop="hrefType">
          <el-select
            v-model.number="linkType"
            size="small"
            placeholder="跳转方式"
          >
            <el-option
              v-for="item in linkTypeList"
              :value="item.value"
              :label="item.label"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="链接地址" prop="joinLink" v-if="linkType == 1">
          <el-input v-model.number="form.joinLink"></el-input>
        </el-form-item>
        <el-form-item label="链接地址:" prop="joinLink" v-if="linkType == 2">
          <el-select
            v-model.number="form.joinLink"
            size="small"
            placeholder="链接地址"
            filterable
          >
            <el-option
              v-for="item in linkList"
              :value="item.value"
              :label="item.label"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="帖子ID"
          prop="postId"
          v-if="form.joinLink == 'yinseinner://postDetails?id='"
        >
          <el-input v-model="postId"></el-input>
        </el-form-item>
        <el-form-item
          label="意见榜单ID"
          prop="solicitId"
          v-if="form.joinLink == 'yinseinner://solicit_opinion_page?id='"
        >
          <el-input v-model="solicitId"></el-input>
        </el-form-item>
        <el-form-item
          label="专题ID"
          prop="topicId"
          v-if="form.joinLink == 'yinseinner://topic_page?id='"
        >
          <el-input v-model="topicId"></el-input>
        </el-form-item>
        <el-form-item
          label="专题标题"
          prop="topicId"
          v-if="form.joinLink == 'yinseinner://topic_page?id='"
        >
          <el-input v-model="topicTitle"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input v-model.number="form.sort"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model="form.status" placeholder="请选择状态">
            <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开始时间:">
          <el-date-picker
            v-model="form.start"
            type="datetime"
            placeholder="选择日期时间"
            size="small"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间:">
          <el-date-picker
            v-model="form.end"
            type="datetime"
            placeholder="选择日期时间"
            size="small"
            width="300px"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="onSubmit()">确 定</el-button>
      </div>
    </el-dialog>
    <RichText ref="richText" @setContent="setContent" />
    <!-- 配置跑马灯 -->
    <el-dialog
      title="评论"
      :visible.sync="showComment"
      width="500px"
      @close="handleClose"
    >
      <el-form :model="commentData" :rules="commentRules" ref="form" label-width="70px">
        <el-form-item label="图片:" prop="cover">
          <base-upload
            class="upload"
            :cover="commentData.image"
            :action="action"
            :wSize="140"
            :hSize="140"
            :width="'140px'"
            :height="'140px'"
            :hedn="true"
            @successCallback="handleMsgImgSuccess"
          ></base-upload>
        </el-form-item>
        <el-form-item label="用户ID" prop="uid">
          <el-input v-model.number="commentData.uid"></el-input>
        </el-form-item>
        <el-form-item label="内容" prop="marqueeStr">
          <el-input
            type="textarea"
            :autosize="{ minRows: 4, maxRows: 8 }"
            class="inp"
            v-model="commentData.content"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showComment = false">取 消</el-button>
        <el-button type="primary" @click="confirmComment()">确 定</el-button>
      </div>
    </el-dialog>
    <!--封面图、视频弹窗组件-->
    <media-popup ref="mediaPopup"></media-popup>
  </div>
</template>

<script>
import API from "@/api";
import { uniteDate } from "@/utils/validator.js";
import MediaPopup from "@/components/media-popup";
import baseConfig from "@/utils/serverUrlConfig";
import local from "@/utils/localStroage.js";
import RichText from "./components/richText";
export default {
  components: {
    RichText,
    MediaPopup,
  },
  data() {
    return {
      // 封面上传地址
      action: baseConfig.baseServerUrl + "/vid/uploadStatic",
      //图集上传
      actionPics: baseConfig.baseServerUrl + "/vid/uploadStaticBatch",
      imgUrl: baseConfig.imgUrl,
      // 表格数据加载动画
      loading: false,
      enables: [
        { label: "启用", value: 1 },
        { label: "禁用", value: 0 },
      ],
      // 列表数据
      tableData: [],
      total: 0,
      params: {
        pageNumber: 1,
        pageSize: 10,
      },
      trackId: "",
      attrs: {
        accept: [
          ".mp4",
          ".qlv",
          ".qsv",
          ".ogg",
          ".flv",
          ".avi",
          ".wmv",
          ".rmvb",
        ], //接受文件类型
      },
      form: {
        id: undefined,
        title: "",
        img: [],
        sourceURL: "",
        content: "1",
        desc: "",
        start: "",
        end: "",
        joinLink: "",
        publisherID: "",
        playTime: undefined,
        sort: undefined,
        status: undefined,
      },
      statusList: [
        { label: "关闭", value: 0 },
        { label: "不可参与", value: 1 },
        { label: "可参与", value: 2 },
      ],
      dialogVisible: false,
      dialogTitle: "",
      rules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
      },
      commentRules: {
        // title: [{ required: true, message: "请输入标题", trigger: "blur" }],
      },
      // 跑马灯
      marqueeLoading: false,
      marqueeVisible: false,
      marqueeForm: {
        marqueeStr: "",
      },
      linkType: undefined,
      linkTypeList: [
        { label: "外部浏览器跳转", value: 1 },
        { label: "内部浏览器跳转", value: 2 },
      ],
      linkList: [
        { label: "专题", value: "yinseinner://topic_page?id=" },
        { label: "帖子详情", value: "yinseinner://postDetails?id=" },
        { label: "会员", value: "yinseinner://vip_page" },
        { label: "钱包", value: "yinseinner://wallet_page" },
        { label: "全民代理", value: "yinseinner://universal_agent" },
        { label: "参赛视频", value: "yinseinner://competition_video_page" },
        { label: "AV解说", value: "yinseinner://av_commentary_page" },
        { label: "抽奖", value: "yinseinner://new_year_lottery_page" },
        { label: "裸聊", value: "yinseinner://nake_chat_page" },
        { label: "娱乐", value: "yinseinner://entertainment_page" },
        { label: "ai脱衣", value: "yinseinner://aiUndress" },
        { label: "签到", value: "yinseinner://sign_page" },
        { label: "意见榜单", value: "yinseinner://solicit_opinion_page?id=" },
        { label: "问题反馈", value: "yinseinner://feedback_page" },
      ],
      topicId: "",
      topicTitle: "",
      postId: "", // 帖子ID
      solicitId: "",
      showComment: false,
      commentData: {
        id: undefined,
        uid: undefined,
        content: undefined,
        image: undefined,
      },
    };
  },
  computed: {
    options() {
      return {
        target: baseConfig.baseServerUrl + "/vid/uploadDotStream", //上传地址
        testChunks: false, //是否开启服务器分片校验
        method: "application/json",
        headers: {
          // 额外请求头
          Authorization: local.get("userInfo")
            ? local.get("userInfo").token
            : "",
        },
        fileParameterName: "upload", //文件名参数，默认为file
        query: this.uploadQuery, //额外参数
        singleFile: true, //单文件上传
        chunkSize: 2048000, //分片大小，默认1M
        simultaneousUploads: 6,
        // 把英文时间转成中文
        parseTimeRemaining: function(timeRemaining, parsedTimeRemaining) {
          return parsedTimeRemaining
            .replace(/\syears?/, "年")
            .replace(/\days?/, "天")
            .replace(/\shours?/, "小时")
            .replace(/\sminutes?/, "分钟")
            .replace(/\sseconds?/, "秒");
        },
      };
    },
  },
  created() {
    this.getModules();
  },
  methods: {
    previewPicture() {},
    // 查看媒体
    checkMedia(url, type) {
      this.$refs.mediaPopup.open(url, type);
    },
    // 请求列表
    getModules(type) {
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      API.queryHotTopic(this.params)
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.tableData = res.data.list;
            this.total = res.data.count;
          } else {
            this.tableData = [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 新增标签配置
    addAndEdit(param) {
      this.dialogVisible = true; // 打开新增、编辑对话框
      // console.log(param)
      if (param === "add") {
        this.dialogTitle = "新增";
      } else {
        this.dialogTitle = "编辑";
        // 把数据回显给表单
        this.form.id = param.id;
        this.form.img = param.img;
        this.form.title = param.title;
        this.form.sourceURL = param.sourceURL;
        this.form.desc = param.desc;
        // this.form.joinLink = param.joinLink;
        this.form.content = param.content;
        this.form.playTime = param.playTime;
        this.form.sort = param.sort;
        this.form.start = param.start;
        this.form.end = param.end;
        this.form.publisherID = param.publisherID;
        if (param.joinLink.indexOf("yinseinner") !== -1) {
          this.linkType = 2;
        } else {
          this.linkType = 1;
        }
        if (param.joinLink.indexOf("topic_page") !== -1) {
          const splitArr = param.joinLink.split("=");
          this.form.joinLink = splitArr[0] + "=";
          let urlIndex = param.joinLink.indexOf("?");
          this.topicId = this.getUrlParam(
            param.joinLink.substring(urlIndex),
            "id"
          );
          this.topicTitle = this.getUrlParam(
            param.joinLink.substring(urlIndex),
            "title"
          );
        } else if (param.joinLink.indexOf("postDetails") !== -1) {
          const splitArr = param.joinLink.split("=");
          this.form.joinLink = splitArr[0] + "=";
          let urlIndex = param.joinLink.indexOf("?");
          this.postId = this.getUrlParam(
            param.joinLink.substring(urlIndex),
            "id"
          );
        } else if (param.joinLink.indexOf("solicit_opinion_page") !== -1) {
          const splitArr = param.joinLink.split("=");
          this.form.joinLink = splitArr[0] + "=";
          let urlIndex = param.joinLink.indexOf("?");
          this.solicitId = this.getUrlParam(
            param.joinLink.substring(urlIndex),
            "id"
          );
        } else {
          this.form.joinLink = param.joinLink;
        }
      }
    },
    comment(row) {
      this.commentData.id = row.id;
      this.showComment = true;
    },
    confirmComment() {
      API.topicComment(this.commentData)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              type: "success",
              message: "评论成功",
            });
            this.showComment = false;
          } else {
            this.$message({
              type: "error",
              message: "评论失败",
            });
          }
        })
        .catch(() => {
          this.$message({
              type: "error",
              message: "评论失败",
            });
        });
    },
    //视频上传选中时
    fileAdd() {
      this.generateTaskId();
    },
    //视频上传额外参数
    uploadQuery(file, chunk) {
      return {
        pos: chunk.offset,
        id: String(this.trackId),
        // totalPos:chunk.offset+1,
        // data:data
      };
    },
    //定义视频上传唯一标识符id
    generateTaskId() {
      const time = new Date().getTime();
      this.trackId = time;
    },
    //视频上传成功时回调函数
    // eslint-disable-next-line no-unused-vars
    onFileSuccess(rootFile, file, response, chunk) {
      let res = JSON.parse(response);
      this.form.sourceURL = res.data.sourceURL;
      this.form.playTime = res.data.playTime;
    },
    handleMsgImgSuccess(res) {
      this.comment.image = res.data.coverImg;
    },
    // 封面图上传成功回调
    successCallbackPic(seriesCover) {
      console.log(seriesCover);
      this.form.img = seriesCover;
    },
    // 新增、修改提交
    onSubmit() {
      if (this.dialogTitle === "新增") {
        this.add();
      } else {
        this.edit();
      }
    },
    // 新增方法
    add() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          // const addData = {
          //   moduleName: this.form.moduleName,
          //   subModuleName: this.form.subModuleName,
          //   sectionLimit: this.form.sectionLimit,
          //   status: this.form.status,
          //   type: this.form.type,
          // };
          if (
            this.form.joinLink == "yinseinner://postDetails?id=" &&
            !this.postId
          ) {
            this.$message({
              type: "error",
              message: "请输入帖子ID",
            });
            return;
          }
          if (
            this.form.joinLink == "yinseinner://solicit_opinion_page?id=" &&
            !this.solicitId
          ) {
            this.$message({
              type: "error",
              message: "请输入意见榜单ID",
            });
            return;
          }
          if (
            this.form.joinLink == "yinseinner://topic_page?id=" &&
            !this.topicId
          ) {
            this.$message({
              type: "error",
              message: "请输入专题ID",
            });
            return;
          }
          if (
            this.form.joinLink == "yinseinner://topic_page?id=" &&
            !this.topicTitle
          ) {
            this.$message({
              type: "error",
              message: "请输入专题标题",
            });
            return;
          }
          if (this.form.joinLink == "yinseinner://topic_page?id=") {
            this.form.joinLink =
              this.form.joinLink + this.topicId + `&title=${this.topicTitle}`;
          }
          if (this.form.joinLink == "yinseinner://postDetails?id=") {
            this.form.joinLink = this.form.joinLink + this.postId;
          }
          if (this.form.joinLink == "yinseinner://solicit_opinion_page?id=") {
            this.form.joinLink = this.form.joinLink + this.solicitId;
          }
          API.addHotTopic(this.form)
            .then((res) => {
              if (res.code === 200) {
                this.$message({
                  type: "success",
                  message: "新增成功",
                });
                this.dialogVisible = false;
                this.getModules();
              } else {
                this.$message({
                  type: "error",
                  message: "新增失败",
                });
              }
            })
            .catch(() => {
              this.$message({
                type: "error",
                message: "服务器异常",
              });
            });
        } else {
          return false;
        }
      });
    },
    // 修改方法
    edit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (
            this.form.joinLink == "yinseinner://postDetails?id=" &&
            !this.postId
          ) {
            this.$message({
              type: "error",
              message: "请输入帖子ID",
            });
            return;
          }
          if (
            this.form.joinLink == "yinseinner://solicit_opinion_page?id=" &&
            !this.solicitId
          ) {
            this.$message({
              type: "error",
              message: "请输入意见榜单ID",
            });
            return;
          }
          if (
            this.form.joinLink == "yinseinner://topic_page?id=" &&
            !this.topicId
          ) {
            this.$message({
              type: "error",
              message: "请输入专题ID",
            });
            return;
          }
          if (
            this.form.joinLink == "yinseinner://topic_page?id=" &&
            !this.topicTitle
          ) {
            this.$message({
              type: "error",
              message: "请输入专题标题",
            });
            return;
          }
          if (this.form.joinLink == "yinseinner://topic_page?id=") {
            this.form.joinLink =
              this.form.joinLink + this.topicId + `&title=${this.topicTitle}`;
          }
          if (this.form.joinLink == "yinseinner://postDetails?id=") {
            this.form.joinLink = this.form.joinLink + this.postId;
          }
          if (this.form.joinLink == "yinseinner://solicit_opinion_page?id=") {
            this.form.joinLink = this.form.joinLink + this.solicitId;
          }
          API.modifyHotTopic(this.form)
            .then((res) => {
              if (res.code === 200) {
                this.$message({
                  type: "success",
                  message: "编辑成功",
                });
                this.dialogVisible = false;
                this.getModules();
              } else {
                this.$message({
                  type: "error",
                  message: "编辑失败",
                });
              }
            })
            .catch(() => {
              this.$message({
                type: "error",
                message: "服务器异常",
              });
            });
        } else {
          return false;
        }
      });
    },
    // 删除方法
    del(param) {
      this.$confirm(
        `确认是否删除<span style='color:blue'>${param.moduleName}</span>, 是否继续?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          let delData = {
            id: param.id,
          };
          API.deleteModule(delData)
            .then((res) => {
              if (res.code === 200) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
              } else {
                this.$message({
                  type: "success",
                  message: "删除失败!",
                });
              }
              this.getModules();
            })
            .catch(() => {
              this.$message({
                type: "error",
                message: "服务器异常!",
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 关闭窗口清除数据
    handleClose() {
      this.form.img = [];
      this.form.title = "";
      this.form.sourceURL = "";
      this.form.desc = "";
      this.form.joinLink = "";
      this.form.content = undefined;
      this.form.playTime = undefined;
      this.form.sort = undefined;
      this.form.start = undefined;
      this.form.end = undefined;
      this.form.publisherID = undefined;
      this.commentData.id = undefined;
      this.commentData.uid = undefined;
      this.commentData.image = undefined;
      this.commentData.content = undefined;
      this.dialogVisible = false;
      this.showComment = false;
    },
    // 配置跑马灯
    // setMarquee() {
    //   this.marqueeVisible = true;
    //   this.marqueeLoading = true;
    //   API.queryMarquee()
    //     .then((res) => {
    //       if (res.code === 200) {
    //         this.marqueeForm.marqueeStr = res.data.content;
    //         this.marqueeLoading = false;
    //       } else {
    //         this.$message({
    //           type: "success",
    //           message: "查询失败!",
    //         });
    //         this.marqueeLoading = false;
    //       }
    //     })
    //     .catch(() => {
    //       this.$message({
    //         type: "error",
    //         message: "服务器异常!",
    //       });
    //       this.marqueeLoading = false;
    //     });
    // },
    // 修改跑马灯
    editMarquee() {
      if (!this.marqueeForm.marqueeStr) return;
      API.modifyMarquee({ marquee: this.marqueeForm.marqueeStr })
        .then((res) => {
          if (res.code === 200) {
            this.marqueeVisible = false;
            this.$message({
              type: "success",
              message: "修改成功",
            });
          } else {
            this.$message({
              type: "success",
              message: "修改失败!",
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "error",
            message: "服务器异常!",
          });
        });
    },
    editRichText() {
      this.$refs.richText.open(this.form.content);
    },
    // 分页条数改变回调
    changeSize(size) {
      this.params.pageSize = size;
      this.getModules();
    },
    // 分页页码改变回调
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber;
      this.getModules();
    },
    // 更换时间格式
    changeTime(time) {
      return uniteDate(time);
    },
    setContent(str) {
      this.form.content = str;
      // console.log(this.form.content, '-=-')
    },
  },
};
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="scss" scoped>
.dialog-footer {
  position: relative;
  left: 50%;
  -webkit-transform: translate(-50%);
  transform: translate(-50%);
}
/deep/ .el-form-item__content {
  display: flex;
}
/deep/ .el-select,
.el-date-editor {
  width: 100% !important;
}
.uploader-drop {
  background: none;
  border-radius: 5px;
  border: none;
  padding: 0;
}
.uploader-file {
  border-bottom: 1px dashed #ccc;
}
.uploader-btn {
  background: #e63765;
  color: white;
  padding: 5px 10px;
  font-size: 13px;
  border: none;
  border-radius: 3px;
  &:hover {
    background: #eb5f84;
  }
}
</style>
